import { defineComponent as _defineComponent } from 'vue'
import SvgIcon from '../common/SvgIcon.vue';
import AudioSettingTab from '../base/AudioSettingTab.vue';
import VideoSettingTab from '../base/VideoSettingTab.vue';
import { useBasicStore } from '../../../stores/basic';
import { storeToRefs } from 'pinia';
import { SettingMode } from '../../../constants/render';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

// import { ref } from 'vue';
const basicStore = useBasicStore();

const { showSettingDialog, activeSettingTab } = storeToRefs(basicStore);
// TODO: 完善其余设置 Tab
const settingTabsTitleList = [
  { label: '声音设置', value: 'audio' },
  { label: '摄像头设置', value: 'video' },
  // { label: '美颜和虚拟设置', value: 'beauty' },
  // { label: '统计功能', value: 'static' },
  // { label: '录制', value: 'record' },
];


function handleUpdateActiveTab(tabTitle: string) {
  basicStore.setActiveSettingTab(tabTitle);
}

function handleCloseSettingDialog() {
  basicStore.setShowSettingDialog(false);
}


return { __sfc: true,basicStore, showSettingDialog, activeSettingTab, settingTabsTitleList, handleUpdateActiveTab, handleCloseSettingDialog, SvgIcon, AudioSettingTab, VideoSettingTab, SettingMode }
}

})